module.exports = __webpack_public_path__ + "media/images/apple_health/watch/stretchlab-c017b00079440c43ceff4f4eb4df5325.svg";